import React from 'react';
import { Box, Typography } from '@mui/material';
import { useMessageMediaAccessQuery } from './useMessageMediaAccessQuery';

const StickerMessageContent = ({ media, messageUuid }) => {
  const { data, isLoading, isError } = useMessageMediaAccessQuery(messageUuid, Boolean(messageUuid));
  const stickerUrl = data?.url ?? media?.signedUrl;

  if (stickerUrl) {
    return (
      <Box
        component="img"
        src={stickerUrl}
        alt={media?.filename || 'Sticker'}
        sx={{ display: 'block', width: '160px', maxWidth: '100%' }}
      />
    );
  }

  if (isLoading) {
    return <Typography variant="body2">Carregando sticker...</Typography>;
  }

  if (isError) {
    return <Typography variant="body2">Nao foi possivel carregar o sticker.</Typography>;
  }

  return <Typography variant="body2">Sticker indisponivel.</Typography>;
};

export default StickerMessageContent;
